<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('leaveRule.leaveRule') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPreData">
        <form>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">
                  {{ $t('leaveRule.employeeType') }}
                </label>
                <div>
                  <ts-search-select
                    v-model.number="model.emp_type_id"
                    :options="
                      employeeTypes.map(e => ({
                        text: e.emp_type_en + '|' + e.emp_type_kh,
                        value: e.emp_type_id
                      }))
                    "
                    :class="{ 'is-invalid': errors.has('emp_type_id') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('emp_type_id')">
                    {{ errors.first('emp_type_id') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">
                  {{ $t('leaveRule.leaveType') }}
                </label>
                <div>
                  <ts-search-select
                    v-model="model.leave_type_id"
                    :options="
                      leaveTypes.map(e => ({
                        text: e.leave_type_en + '|' + e.leave_type_kh,
                        value: e.leave_type_id
                      }))
                    "
                    :class="{ 'is-invalid': errors.has('leave_type_id') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('leave_type_id')">
                    {{ errors.first('leave_type_id') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">
                  {{ $t('leaveRule.totalDayAllow') }}
                </label>
                <div>
                  <ts-input
                    type="number"
                    :class="{ 'is-invalid': errors.has('total_day_allow') }"
                    v-model.number="model.total_day_allow"
                  ></ts-input>
                  <div class="invalid-feedback" v-if="errors.has('total_day_allow')">
                    {{ errors.first('total_day_allow') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label">
                  {{ $t('leaveRule.incrementDay') }}
                </label>
                <div>
                  <ts-input
                    type="number"
                    :class="{ 'is-invalid': errors.has('increment_day') }"
                    v-model.number="model.increment_day"
                  ></ts-input>
                  <div class="invalid-feedback" v-if="errors.has('increment_day')">
                    {{ errors.first('increment_day') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label">
                  {{ $t('leaveRule.incrementIntervalYear') }}
                </label>
                <div>
                  <ts-input
                    type="number"
                    :class="{ 'is-invalid': errors.has('increment_interval_year') }"
                    v-model.number="model.increment_interval_year"
                  ></ts-input>
                  <div class="invalid-feedback" v-if="errors.has('increment_interval_year')">
                    {{ errors.first('increment_interval_year') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label">
                  {{ $t('leaveRule.maxDayAllowCarryForward') }}
                </label>
                <div>
                  <ts-input
                    type="number"
                    :class="{ 'is-invalid': errors.has('increment_interval_year') }"
                    v-model.number="model.max_day_allow_carry_forward"
                  ></ts-input>
                  <div class="invalid-feedback" v-if="errors.has('increment_interval_year')">
                    {{ errors.first('increment_interval_year') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label">
                  {{ $t('leaveRule.carryForwardClearanceInMonth') }}
                </label>
                <div>
                  <ts-date-picker-input
                    format="MM"
                    :class="{ 'is-invalid': errors.has('carry_forward_clearance_in_month') }"
                    v-model="model.carry_forward_clearance_in_month"
                  ></ts-date-picker-input>
                  <div class="invalid-feedback" v-if="errors.has('carry_forward_clearance_in_month')">
                    {{ errors.first('carry_forward_clearance_in_month') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label class="col-form-label control-label required">
                  {{ $t('leaveRule.cycleStart') }}
                </label>
                <div>
                  <ts-date-picker-input
                    format="DD-MM"
                    :class="{ 'is-invalid': errors.has('cycle_start_ddmm') }"
                    v-model="model.cycle_start_ddmm"
                  ></ts-date-picker-input>
                  <div class="invalid-feedback" v-if="errors.has('cycle_start_ddmm')">
                    {{ errors.first('cycle_start_ddmm') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <label class="col-form-label control-label required">
                {{ $t('leaveRule.cycleStop') }}
              </label>
              <div class="form-group m-b-10">
                <div>
                  <ts-date-picker-input
                    format="DD-MM"
                    :class="{ 'is-invalid': errors.has('cycle_stop_ddmm') }"
                    v-model="model.cycle_stop_ddmm"
                  ></ts-date-picker-input>
                  <div class="invalid-feedback" v-if="errors.has('cycle_stop_ddmm')">
                    {{ errors.first('cycle_stop_ddmm') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <div>
                  <ts-checkbox v-model="model.allow_leave_when_no_balance">{{
                    $t('leaveRule.allowLeave')
                  }}</ts-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-6">
            <div class="col-sm-12 col-lg-12 col-md-12 text-right">
              <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
              <ts-button
                outline
                color="primary"
                class="ml-2"
                :waiting="savingAndNew"
                @click.prevent="saveAndNew"
                v-if="editData === undefined"
                >{{ $t('button.createAndNew') }}</ts-button
              >
              <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">{{
                editData ? $t('button.update') : $t('button.create')
              }}</ts-button>
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  props: ['editData'],
  name: 'leave-rule-form',
  data() {
    return {
      model: {
        emp_type_id: '',
        leave_type_id: '',
        total_day_allow: '',
        increment_day: 0,
        increment_interval_year: 0,
        allow_leave_when_no_balance: 0,
        max_day_allow_carry_forward: 0,
        carry_forward_clearance_in_month: '',
        cycle_start_ddmm: '',
        cycle_stop_ddmm: ''
      },
      errors: new Errors(),
      saving: false,
      savingAndNew: false,
      loadingPreData: true
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('hr/leaveRule', ['employeeTypes', 'leaveTypes'])
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.$store
        .dispatch('hr/leaveRule/dataBeforeCreate')
        .then(response => {
          this.loadingPreData = false
          this.setData()
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    submit() {
      let responseResult

      this.errors = new Errors()

      responseResult = this.$store.dispatch('hr/leaveRule/store', this.model)

      return responseResult
        .then(response => {
          return this.$store.dispatch('hr/leaveRule/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)

          return Promise.reject(error)
        })
    },
    save() {
      this.saving = true

      this.submit()
        .then(() => {
          this.$emit('close')
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveAndNew() {
      this.savingAndNew = true

      this.submit()
        .then(() => {
          this.clear()
        })
        .finally(() => {
          this.savingAndNew = false
        })
    },
    setData() {
      if (!_.isEmpty(this.editData)) {
        this.model = {
          emp_type_id: this.editData.emp_type_id,
          leave_type_id: this.editData.leave_type_id,
          total_day_allow: this.editData.total_day_allow,
          increment_day: this.editData.increment_day,
          increment_interval_year: this.editData.increment_interval_year,
          allow_leave_when_no_balance: this.editData.allow_leave_when_no_balance,
          max_day_allow_carry_forward: this.editData.max_day_allow_carry_forward,
          carry_forward_clearance_in_month: this.editData.carry_forward_clearance_in_month,
          cycle_start_ddmm: this.editData.cycle_start_ddmm,
          cycle_stop_ddmm: this.editData.cycle_stop_ddmm
        }
      }
    },
    clear() {
      this.model = {
        emp_type_id: '',
        leave_type_id: '',
        total_day_allow: '',
        increment_day: '',
        increment_interval_year: '',
        allow_leave_when_no_balance: '',
        max_day_allow_carry_forward: '',
        carry_forward_clearance_in_month: '',
        cycle_start_ddmm: '',
        cycle_stop_ddmm: ''
      }
    }
  }
}
</script>
